import { render, staticRenderFns } from "./AddSitetypeDialog.vue?vue&type=template&id=24450287&scoped=true"
import script from "./AddSitetypeDialog.vue?vue&type=script&lang=js"
export * from "./AddSitetypeDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24450287",
  null
  
)

export default component.exports